var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "comments" },
    [
      _vm.dataLoaded && _vm.showModal
        ? _c(
            "modal-box",
            {
              attrs: { open: _vm.dataLoaded && _vm.showModal, width: "1080px" },
              domProps: {
                onClose: () => (_vm.showModal = false),
                enableHeader: true,
                enableFooter: true,
                enableHeaderClose: true,
                transparentOverlay: false,
                closeOnClickOutside: true,
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "line-height": "var(--adam-d48)" },
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "flex-row flex-1" }, [
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.commentToEdit.assetName))]),
                    ]),
                    _c("span", { staticClass: "separator ml-6 mr-4 mt-2" }),
                    _c("div", { staticClass: "flex-col flex-2" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.commentToEdit.attributeName)),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _c("span", [
                _c("div", { staticClass: "flex-col edit-comment" }, [
                  _c("div", { staticClass: "mt-3 ui-text" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ui-text-label",
                        attrs: { for: "uiTextOldValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("oldValue")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.commentOldValue,
                          expression: "commentOldValue",
                        },
                      ],
                      staticClass: "ui-text-input",
                      attrs: {
                        id: "uiTextOldValue",
                        placeholder: "Value",
                        readonly: true,
                      },
                      domProps: { value: _vm.commentOldValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.commentOldValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 ui-text" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ui-text-label",
                        attrs: { for: "uiTextValue" },
                      },
                      [_vm._v(_vm._s(_vm.$t("newValue")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.commentToEdit.attributeValue,
                          expression: "commentToEdit.attributeValue",
                        },
                      ],
                      staticClass: "ui-text-input",
                      attrs: { id: "uiTextValue", placeholder: "Value" },
                      domProps: { value: _vm.commentToEdit.attributeValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.commentToEdit,
                            "attributeValue",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "mt-3 ui-text" }, [
                    _c(
                      "label",
                      {
                        staticClass: "ui-text-label",
                        attrs: { for: "uiTextReason" },
                      },
                      [_vm._v(_vm._s(_vm.$t("reason")))]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.commentToEdit.updComment,
                          expression: "commentToEdit.updComment",
                        },
                      ],
                      staticClass: "ui-text-input",
                      attrs: { id: "uiTextReason", placeholder: "Value" },
                      domProps: { value: _vm.commentToEdit.updComment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.commentToEdit,
                            "updComment",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { class: _vm.errorExists ? "error-text" : "" }, [
                    _vm.errorExists
                      ? _c("div", [_vm._v("This field is mandatory")])
                      : _vm._e(),
                  ]),
                ]),
                _c("br"),
              ]),
              _c(
                "span",
                {
                  staticStyle: { "line-height": "var(--adam-d48)" },
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("div", { staticClass: "flex-row reverse" }, [
                    _c(
                      "div",
                      { staticClass: "flex-col flex-align-end" },
                      [
                        _c(
                          "adam-button",
                          {
                            attrs: { secondary: "", icon: "ic-station" },
                            on: { click: _vm.save },
                          },
                          [_vm._v("Save")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("bulk-update-upload", {
        attrs: { "show-bulk-update": _vm.showBulkUpdateModal },
        on: {
          close: function ($event) {
            _vm.showBulkUpdateModal = false
          },
        },
      }),
      !_vm.dataLoaded
        ? _c("div", { staticClass: "popup" }, [_c("eas-loader")], 1)
        : _vm._e(),
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex-row flex-1",
                    staticStyle: { "align-items": "center" },
                  },
                  [
                    _c("div", { staticClass: "flex-col" }, [
                      _c("div", { staticClass: "flex-row flex-1" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-col ml-5",
                            staticStyle: { width: "30rem" },
                          },
                          [
                            _c("CustomSelect", {
                              staticClass: "select",
                              attrs: {
                                options: _vm.assets,
                                default: _vm.defaultAsset,
                                displayKey: "name",
                              },
                              on: { input: _vm.onAssetChange },
                            }),
                          ],
                          1
                        ),
                        _c("span", { staticClass: "separator ml-6 mr-4" }),
                        _c(
                          "div",
                          {
                            staticClass: "flex-col ml-2",
                            staticStyle: { width: "30rem" },
                          },
                          [
                            _c("CustomSelect", {
                              staticClass: "select",
                              attrs: {
                                options: _vm.commentAttributes,
                                default: _vm.defaultAttrib,
                                displayKey: "attributeTitle",
                              },
                              on: { input: _vm.onTitleChange },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "flex-col flex-1 mr-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex-row",
                          staticStyle: { "justify-content": "flex-end" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex-col mr-1",
                              staticStyle: { "justify-content": "center" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  on: { click: _vm.downloadTemplate },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("downloadTemplate")) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex-col",
                              staticStyle: { "justify-content": "center" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  on: { click: _vm.showBulkUpdate },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("bulkUpdate")) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "separator ml-4 mr-4" }),
                          _c(
                            "div",
                            { staticClass: "flex-col page-size-label pr-2" },
                            [_vm._v("Page Size: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "flex-col",
                              staticStyle: { "align-items": "flex-end" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.pageSize,
                                      expression: "pageSize",
                                    },
                                  ],
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.pageSize = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.changePageSize,
                                    ],
                                  },
                                },
                                _vm._l(_vm.pageSizeSelection, function (size) {
                                  return _c(
                                    "option",
                                    { key: size, domProps: { value: size } },
                                    [_vm._v(_vm._s(size))]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "flex-row" }, [
                  _c("div", { staticClass: "flex-col flex-1" }),
                  _c(
                    "div",
                    { staticClass: "flex-col flex-12" },
                    [
                      !_vm.pagingData.totalPageCount
                        ? _c("div", [_vm._v(" No Data Available ")])
                        : _c("paging", {
                            attrs: { pagingData: _vm.pagingData },
                            on: { "current-page": _vm.modifyContent },
                            scopedSlots: _vm._u([
                              {
                                key: "pageContent",
                                fn: function () {
                                  return _vm._l(_vm.comments, function (cmnt) {
                                    return _c("CommentComponent", {
                                      key: cmnt.sno,
                                      staticClass: "mb-1",
                                      attrs: { comment: cmnt },
                                      on: { "on-edit": _vm.editComment },
                                    })
                                  })
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }